import React from 'react';

import { IOffers } from '../../models/content.interfaces';

import {
  APP,
  BANNER,
  OFFERS,
  PRODUCT_QUICK_LINKS,
  QUICK_LINKS,
  READY_TO_SWITCH,
  REWARDS_BENEFITS,
  TRUST_PILOT,
} from '../../consts/staticContent';
import { COLOURS } from '../../consts/style';

import { App } from '../App';
import { HeroBanner } from '../Banner/HeroBanner';
import { Offers } from '../Offers';
import { ProductQuickLinks } from '../ProductsQuickLinks';
import { QuickLinks } from '../QuickLinks';
import { RewardsBenefits } from '../RewardsBenefits';
import { Section, SectionSidePadding } from '../Common';
import { TrustPilot, useTrustPilotSummary, useTrustPilotReviews } from '../TrustPilot';
import ReadyToSwitch from '../ReadyToSwitch';
import { useAbTitleSwitchOnVisibility } from '../useAbTest/useAbTest';
import { HiddenContentCard } from '../Test/HiddenContentCard';

export const PageContent = () => {
  const reviewsList = useTrustPilotReviews();
  const reviewsSummary = useTrustPilotSummary();
  useAbTitleSwitchOnVisibility();

  return (
    <main>
      <Section paddingTop={false} variant="full_width">
        <HeroBanner {...BANNER} />
        <SectionSidePadding>
          <QuickLinks {...QUICK_LINKS} />
        </SectionSidePadding>
      </Section>
      <Section paddingTop={false}>
        <ProductQuickLinks {...PRODUCT_QUICK_LINKS} />
      </Section>
      <Section variant="full_width" paddingTop={false}>
        <Offers {...(OFFERS as IOffers)} />
      </Section>
      <Section paddingTop={false}>
        <RewardsBenefits {...REWARDS_BENEFITS} />
      </Section>
      {/* if reviews api is down, just hide the reviews section */}
      {reviewsList.status !== 'Error' && reviewsSummary.status !== 'Error' && (
        <Section variant="full_width" bgColor={COLOURS.NEUTRALS.BACKGROUND_LIGHT}>
          {reviewsList.status === 'Success' && reviewsSummary.status === 'Success' && (
            <TrustPilot
              heading={TRUST_PILOT.sectionHeading}
              summary={reviewsSummary.data}
              reviews={reviewsList.data.reviews}
            />
          )}
        </Section>
      )}
      <Section>
        <App {...APP} />
      </Section>
      <Section bgColor={COLOURS.NEUTRALS.BACKGROUND_LIGHT}>
        <ReadyToSwitch {...READY_TO_SWITCH} />
      </Section>
      {/* component for confirming Braze numbers */}
      <HiddenContentCard />
    </main>
  );
};
